// app/javascript/compcalc/components/utls/ComboBoxList.jsx

import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import Input from '@material-ui/core/Input';
import ListItem from '@material-ui/core/ListItem';
import Select from '@material-ui/core/Select';


const styles = theme => ({
  alignCenter: {
    width: '100%',
    textAlign: 'center',
  },
});


class ComboBoxList extends React.PureComponent {

  constructor(props) {
    super(props);
  }

  onIndexChanged = (index, wpi) => {
    // console.log(`ComboBoxList.onWpiIndexChanged(): ${index}, ${wpi}`);
  }

  // --------------------- Rendering ---------------------
  render() {
    const { classes } = this.props;

    // props.comboBoxItems = array of strings, props.items = array of indexes (in comboBoxItems),
    // props.selectedIndex, props.onIndexChanged(), props.onComboBoxChanged()
    return (
      <div>
        {
          this.props.items.map((item, index) => (
            <ListItem dense button key={`${index}`}
                      selected={this.props.selectedIndex === index}
                      onClick={() => this.props.onIndexChanged(index)}>
              <div className={classes.alignCenter}>
                <Select
                  variant="outlined"
                  value={ this.props.items[index] }
                  onChange={ e => this.props.onComboBoxChanged(e.target.name, e.target.value) }
                  input={<Input id={ `${index}` } name={ `${index}` } />}
                  autoWidth
                >
                  { this.props.comboBoxItems }
                </Select>
              </div>
            </ListItem>
          ))
        }
      </div>
    );
  }
};

export default withStyles(styles)(ComboBoxList);
